export const numberOfSkeletons: number = 4;
